import { type ChangeEvent } from 'react';

import { classNames } from '../../server/utils/classNames';

export type OnInputEvent<T extends HTMLInputElement | HTMLTextAreaElement> = ChangeEvent<T> & {
	inputType?: string;
};

const baseInputStyles = classNames(
	'w-full flex-1 outline-hidden text-body p-0 bg-transparent border-0',
	'focus:ring-transparent focus:placeholder:opacity-100 text-content-primary',
	/** super hacky css to get rid of the autofill background set by browsers */
	'autofill:transition-[background-color] autofill:ease-out autofill:duration-[9999s]',
	'autofill:!bg-none autofill:hover:!bg-none autofill:focus:!bg-none autofill:active:!bg-none', //special case for firefox, beacuse it uses background-image property under the hood and we need to reset it,
	'dark:autofill:autofill-dark-text-override',
);

export const getTextInputStyles = (invalid: boolean, disabled: boolean | undefined) => {
	return classNames(baseInputStyles, 'mt-4 placeholder:opacity-0', {
		'text-content-primary': invalid && !disabled,
		'cursor-not-allowed text-content-disabled-primary': disabled,
	});
};

export const getSearchInputStyles = (disabled: boolean | undefined) => {
	return classNames(baseInputStyles, 'mt-0 pl-1.5', '[&::-webkit-search-cancel-button]:hidden', {
		'cursor-not-allowed placeholder-content-disabled-primary text-content-disabled-primary': disabled,
	});
};
